import { createFileRoute } from "@tanstack/react-router";
import { getWorkspaceIdWithFallback } from "@/lib/routing/workspace-context";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute(
  "/workspace/$workspaceSlug/settings/workspace/billing/invoices",
)({
  loader: async ({ context, parentMatchPromise }) => {
    const workspaceId = await getWorkspaceIdWithFallback(
      context,
      "billing-invoices",
      parentMatchPromise,
    );
    // In Phase 5, invoices are not fully implemented or require mock data.
    // For now we just return workspaceId.
    return { workspaceId };
  },
  component: InvoicesPage,
});

function InvoicesPage() {
  const { t } = useTranslation("billing");
  return (
    <div className="space-y-6 p-6 max-w-5xl">
      <div>
        <h2 className="text-2xl font-bold tracking-tight">{t("invoices.title", "Invoices")}</h2>
        <p className="text-muted-foreground">
          {t("invoices.description", "View and download your past invoices.")}
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>{t("invoices.history_title", "Invoice history")}</CardTitle>
          <CardDescription>
            {t(
              "invoices.history_description",
              "Invoices are generated monthly. This is a placeholder for Phase 5.",
            )}
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="text-sm text-muted-foreground py-8 text-center border border-dashed rounded-md">
            {t("invoices.empty", "No invoices found.")}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
